import React, { useEffect, useState } from "react";

const Metrics = () => {
    const [data, setData] = useState(null);
    const API_URL = process.env.REACT_APP_METRICS_URL;

    useEffect(() => {
        fetch(API_URL)
            .then((res) => res.json())
            .then((json) => setData(json.data[0]))
            .catch((err) => console.error("Failed to fetch data:", err));
    }, [API_URL]);

    if (!data) {
        return <div className="text-center py-10 text-gray-500">Loading...</div>;
    }

    const impressions = parseInt(data.impressions);
    const spend = parseFloat(data.spend);
    const cpm = parseFloat(data.cpm);
    const linkClickObj = data.actions.find((action) => action.action_type === "link_click");
    const linkClicks = linkClickObj ? parseInt(linkClickObj.value) : 0;
    const ctr = impressions > 0 ? ((linkClicks / impressions) * 100).toFixed(2) : "0.00";
    const cpc = linkClicks > 0 ? (spend / linkClicks).toFixed(4) : "0.0000";

    return (
        <div dir="ltr" className="bg-blue-800 text-white p-4 mdd:p-6 lgg:p-10">
            <h2 className="text-xl mdd:text-2xl lgg:text-3xl font-bold mb-6 text-center">
                Ad Campaign Metrics
            </h2>

            <div className="overflow-x-auto rounded shadow-lg">
                <table className="w-full border border-gray-700 text-sm mdd:text-base">
                    <thead className="bg-yellow-500 text-black">
                        <tr className="text-center">
                            <th className="p-2 border">Metric</th>
                            <th className="p-2 border">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="p-2 border text-center">Impressions</td>
                            <td className="p-2 border text-center">{impressions}</td>
                        </tr>
                        <tr>
                            <td className="p-2 border text-center">Spend (€)</td>
                            <td className="p-2 border text-center">{spend}</td>
                        </tr>
                        <tr>
                            <td className="p-2 border text-center">CPM (€)</td>
                            <td className="p-2 border text-center">{cpm.toFixed(7)}</td>
                        </tr>
                        <tr>
                            <td className="p-2 border text-center">CTR (%)</td>
                            <td className="p-2 border text-center">{ctr}</td>
                        </tr>
                        <tr>
                            <td className="p-2 border text-center">CPC (€)</td>
                            <td className="p-2 border text-center">{cpc}</td>
                        </tr>
                        <tr>
                            <td className="p-2 border text-center">Date Range</td>
                            <td className="p-2 border text-center">
                                {data.date_start} → {data.date_stop}
                            </td>
                        </tr>
                        <tr>
                            <td className="p-2 border text-center align-top">Actions</td>
                            <td className="p-2 border">
                                <div className="overflow-x-auto">
                                    <table className="w-full border border-gray-600 text-xs sm:text-sm mdd:text-base">
                                        <thead className="bg-yellow-500 text-black">
                                            <tr>
                                                <th className="p-1 border">Action Type</th>
                                                <th className="p-1 border">Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.actions.map((action, i) => (
                                                <tr key={i}>
                                                    <td className="p-1 border">{i + 1} - {action.action_type}</td>
                                                    <td className="p-1 border text-center">{action.value}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Metrics;
